/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface TasksSummary
 */
export interface TasksSummary {
    /**
     * 
     * @type {Array<TaskInfo>}
     * @memberof TasksSummary
     */
    running: Array<TaskInfo>;
    /**
     * 
     * @type {Array<TaskInfo>}
     * @memberof TasksSummary
     */
    recentFinished: Array<TaskInfo>;
    /**
     * 
     * @type {number}
     * @memberof TasksSummary
     */
    pendingCount: number;
}

export function TasksSummaryFromJSON(json: any): TasksSummary {
    return TasksSummaryFromJSONTyped(json, false);
}

export function TasksSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TasksSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'running': ((json['running'] as Array<any>).map(TaskInfoFromJSON)),
        'recentFinished': ((json['recent_finished'] as Array<any>).map(TaskInfoFromJSON)),
        'pendingCount': json['pending_count'],
    };
}

export function TasksSummaryToJSON(value?: TasksSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'running': ((value.running as Array<any>).map(TaskInfoToJSON)),
        'recent_finished': ((value.recentFinished as Array<any>).map(TaskInfoToJSON)),
        'pending_count': value.pendingCount,
    };
}


